import { useState, useEffect } from 'react';

export const useTypewriter = (text, speed = 30, trigger = true) => {
  const [displayed, setDisplayed] = useState("");
  const [isDone, setIsDone] = useState(false);

  useEffect(() => {
    if (!trigger) return;
    setDisplayed("");
    setIsDone(false);
    let i = 0;
    const timer = setInterval(() => {
      if (i < text.length) {
        setDisplayed(text.slice(0, ++i));
      } else {
        setIsDone(true);
        clearInterval(timer);
      }
    }, speed);
    return () => clearInterval(timer);
  }, [text, speed, trigger]);

  return { displayed, isDone };
};
